import * as React from 'react';
import { StyledHTMLElement } from 'styletron-react';
import { styled } from 'styletron-react';

export const LabelStyle: React.CSSProperties = {
    alignItems: 'center',
    color: 'rgba(0,0,0,0.6)',
    display: 'inline-flex',
    fontFamily: 'Segoe UI',
    fontSize: '1rem',
    fontWeight: 400,
    verticalAlign: 'middle',
};

export const Label = styled('label', LabelStyle);



// WEBPACK FOOTER //
// ./primitives/Label.tsx